export default __webpack_public_path__ + "static/media/snowball.cefa1f44.mp3";